// extracted by mini-css-extract-plugin
export default {"root":"FormCardButton_root__hfkmG","disabled":"FormCardButton_disabled__iWz3s","text":"FormCardButton_text__q-tM5"};